<template>
  <div>
    <div class="my-container">
      <h2>Cell Functional States Exploration</h2>
      <div class="content">
        <el-form ref="form" :model="formData" label-width="100px" size="small" style="padding-top: 10px;" inline>
          <el-form-item label="Type">
            <el-select v-model="formData.Type" placeholder="please select"
                       @change="getDatasets">
              <el-option
                  v-for="item in typelist"
                  :key="item"
                  :label="item"
                  :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Dataset">
            <el-select v-model="formData.DatasetID" placeholder="please select"
                       @change="getSample">
              <el-option
                  v-for="item in dataset_list"
                  :key="item"
                  :label="item"
                  :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Sample">
            <el-select v-model="formData.Sample" placeholder="please select"
                       @change="getStateData">
              <el-option
                  v-for="item in sample_list"
                  :key="item"
                  :label="item"
                  :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="content">
        <div id="img_left" class="left" style="aspect-ratio: 1/1">
          <img :src="img_path" width="100%"  @error="errorFunction" @load="sucessFunction" alt="error" style="padding-top: 100px"/>
        </div>
        <div id="img_right" class="right" style="aspect-ratio: 1/1">
          <div id="main" style="height: 600px;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import * as d3 from 'd3'
import * as echarts from 'echarts/core';
import {
  TooltipComponent,
  GridComponent,
  VisualMapComponent,
  LegendComponent
} from 'echarts/components';
import { ScatterChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  TooltipComponent,
  GridComponent,
  VisualMapComponent,
  LegendComponent,
  ScatterChart,
  CanvasRenderer,
  UniversalTransition
]);

export default {
  name: "State",
  data() {
    return{
      typelist: [
          'Breast cancer','PDAC','cSCC','Melanoma','Prostate cancer',
          'Liver cancer', 'Ovariancancer','Glioblastoma', 'Colorectal Cancer','Cervical Cancer',
          'Intestine Cancer', 'Bladder Cancer', 'Brain metastases', 'Lung Cancer'
      ],
      dataset_list: [],
      sample_list: [],
      state_list: ["Angiogenesis","Apoptosis","CellCycle","Differentiation","DNADamage","DNARepair",
        "EMT","Hypoxia","Inflammation","Invasion","Metastasis","Proliferation","Quiescence","Stemness"],
      formData: {
        Type: 'Breast cancer',
        DatasetID: '20210101',
        Sample: 'IDC',
        State: 'Angiogenesis'
      },
      img_path: '',
      state_data: {
        Angiogenesis: [],
        Apoptosis: [],
        CellCycle: [],
        Differentiation: [],
        DNADamage: [],
        DNARepair: [],
        EMT: [],
        Hypoxia: [],
        Inflammation: [],
        Invasion: [],
        Metastasis: [],
        Proliferation: [],
        Quiescence: [],
        Stemness: [],
      },

      SVG:{
        path: '',
        width: '1000',
        height: '1000',
      },
    }
  },
  methods: {
    getDatasets(){
      let _this = this
      console.log('type:    '+_this.formData.Type)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost + '/state/type/' + _this.formData.Type)
          .then(function (response){
            console.log('datasetID_list:')
            console.log(response)
            _this.dataset_list = response.data.dataset_list
            _this.formData.DatasetID = ''
            _this.formData.Sample = ''
            console.log(_this.dataset_list)
          })
    },
    getSample(){
      let _this = this
      console.log(_this.formData.DatasetID)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/state/'+ _this.formData.DatasetID)
          .then(function (response){
            console.log('sample_list:')
            console.log(response)
            _this.sample_list = response.data.sample_list
            _this.formData.Sample = ''
            console.log(_this.sample_list)
          })
    },
    getStateData(){
      let _this = this
      _this.getImgPath()
      console.log(_this.formData.DatasetID+" "+_this.formData.Type+" "+_this.formData.State)
      _this.formData.State = 'Angiogenesis'
      _this.state_data.Angiogenesis = []
      _this.state_data.Apoptosis= []
      _this.state_data.CellCycle = []
      _this.state_data.Differentiation = []
      _this.state_data.DNADamage = []
      _this.state_data.DNARepair = []
      _this.state_data.EMT = []
      _this.state_data.Hypoxia = []
      _this.state_data.Inflammation = []
      _this.state_data.Invasion = []
      _this.state_data.Metastasis = []
      _this.state_data.Proliferation = []
      _this.state_data.Quiescence = []
      _this.state_data.Stemness = []
      // console.log(resolve,reject)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/state/'+ _this.formData.DatasetID
          +'/'+ _this.formData.Sample +'/'+ _this.formData.State )
          .then(function (response){
            console.log('stateData:')
            console.log(response)
            _this.state_data[_this.formData.State] = response.data[_this.formData.State]
            console.log(_this.state_data)
            const myChart = echarts.getInstanceByDom(document.getElementById('main'));
            // if (chartDom == null) { // 如果不存在，就进行初始化。
            //   chartDom = echarts.init(document.getElementById(id));
            // }
            // const myChart = echarts.init(chartDom);
            let option;
            const itemStyle = {
              emphasis: {
                focus : 'self'
              }
            };
            myChart.setOption({
              legend: {selected: {[_this.formData.State]: true}},
              series: [
                {
                  type: 'scatter',
                  itemStyle: itemStyle,
                  large: true,                //是否开启大规模散点图的优化，在数据图形特别多的时候（>=5k）可以开启。开启后配合 largeThreshold 在数据量大于指定阈值的时候对绘制进行优化。缺点：优化后不能自定义设置单个数据项的样式。
                  largeThreshold:5000,        //开启绘制优化的阈值。
                  data: _this.state_data.Angiogenesis,
                  symbolSize: 5,
                  name: 'Angiogenesis',
                },
                {
                  name: 'Apoptosis',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Apoptosis,
                  symbolSize: 5
                },
                {
                  name: 'Cell cycle',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.CellCycle,
                  symbolSize: 5
                },
                {
                  name: 'Differentiation',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Differentiation,
                  symbolSize: 5
                },
                {
                  name: 'DNA damage',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.DNADamage,
                  symbolSize: 5
                },
                {
                  name: 'DNA repair',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.DNARepair,
                  symbolSize: 5
                },
                {
                  name: 'EMT',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.EMT,
                  symbolSize: 5
                },
                {
                  name: 'Hypoxia',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Hypoxia,
                  symbolSize: 5
                },
                {
                  name: 'Inflammation',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Inflammation,
                  symbolSize: 5
                },
                {
                  name: 'Invasion',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Invasion,
                  symbolSize: 5
                },
                {
                  name: 'Metastasis',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Metastasis,
                  symbolSize: 5
                },
                {
                  name: 'Proliferation',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Proliferation,
                  symbolSize: 5
                },
                {
                  name: 'Quiescence',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Quiescence,
                  symbolSize: 5
                },
                {
                  name: 'Stemness',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Stemness,
                  symbolSize: 5
                },
              ]
            })
            // chartDom.setAttribute('_echarts_instance_', '')
            option && myChart.setOption(option,true);
          })
          .catch(function (error) {
            console.log('error:')
            console.log(error)
            const myChart = echarts.getInstanceByDom(document.getElementById('main'));
            // if (chartDom == null) { // 如果不存在，就进行初始化。
            //   chartDom = echarts.init(document.getElementById(id));
            // }
            // const myChart = echarts.init(chartDom);
            let option;
            const itemStyle = {
              emphasis: {
                focus : 'self'
              }
            };
            myChart.setOption({
              legend: {selected: {[_this.formData.State]: true}},
              series: [
                {
                  type: 'scatter',
                  itemStyle: itemStyle,
                  large: true,                //是否开启大规模散点图的优化，在数据图形特别多的时候（>=5k）可以开启。开启后配合 largeThreshold 在数据量大于指定阈值的时候对绘制进行优化。缺点：优化后不能自定义设置单个数据项的样式。
                  largeThreshold:5000,        //开启绘制优化的阈值。
                  data: _this.state_data.Angiogenesis,
                  symbolSize: 5,
                  name: 'Angiogenesis',
                },
                {
                  name: 'Apoptosis',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Apoptosis,
                  symbolSize: 5
                },
                {
                  name: 'Cell cycle',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.CellCycle,
                  symbolSize: 5
                },
                {
                  name: 'Differentiation',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Differentiation,
                  symbolSize: 5
                },
                {
                  name: 'DNA damage',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.DNADamage,
                  symbolSize: 5
                },
                {
                  name: 'DNA repair',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.DNARepair,
                  symbolSize: 5
                },
                {
                  name: 'EMT',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.EMT,
                  symbolSize: 5
                },
                {
                  name: 'Hypoxia',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Hypoxia,
                  symbolSize: 5
                },
                {
                  name: 'Inflammation',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Inflammation,
                  symbolSize: 5
                },
                {
                  name: 'Invasion',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Invasion,
                  symbolSize: 5
                },
                {
                  name: 'Metastasis',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Metastasis,
                  symbolSize: 5
                },
                {
                  name: 'Proliferation',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Proliferation,
                  symbolSize: 5
                },
                {
                  name: 'Quiescence',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Quiescence,
                  symbolSize: 5
                },
                {
                  name: 'Stemness',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Stemness,
                  symbolSize: 5
                },
              ]
            })
            // chartDom.setAttribute('_echarts_instance_', '')
            option && myChart.setOption(option,true);

          })
    },
    changeSelect() {
      let _this = this
      console.log(_this.formData.DatasetID+" "+_this.formData.Type+" "+_this.formData.State)
      // console.log(resolve,reject)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/state/'+ _this.formData.DatasetID
          +'/'+ _this.formData.Sample +'/'+ _this.formData.State )
          .then(function (response){
            console.log('stateData:')
            console.log(response.data)
            let name = Object.keys(response.data).pop()
            console.log(name)
            _this.state_data[name] = response.data[name]
            // _this.state_data[_this.formData.State] = response.data[_this.formData.State]
            console.log(_this.state_data)

            const myChart = echarts.getInstanceByDom(document.getElementById('main'));
            // if (chartDom == null) { // 如果不存在，就进行初始化。
            //   chartDom = echarts.init(document.getElementById(id));
            // }
            // const myChart = echarts.init(chartDom);
            let option;
            const itemStyle = {
              emphasis: {
                focus : 'self'
              }
            };
            myChart.setOption({
              legend: {selected: {[_this.formData.State]: true}},
              series: [
                {
                  type: 'scatter',
                  itemStyle: itemStyle,
                  large: true,                //是否开启大规模散点图的优化，在数据图形特别多的时候（>=5k）可以开启。开启后配合 largeThreshold 在数据量大于指定阈值的时候对绘制进行优化。缺点：优化后不能自定义设置单个数据项的样式。
                  largeThreshold:5000,        //开启绘制优化的阈值。
                  data: _this.state_data.Angiogenesis,
                  symbolSize: 5,
                  name: 'Angiogenesis',
                },
                {
                  name: 'Apoptosis',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Apoptosis,
                  symbolSize: 5
                },
                {
                  name: 'Cell cycle',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.CellCycle,
                  symbolSize: 5
                },
                {
                  name: 'Differentiation',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Differentiation,
                  symbolSize: 5
                },
                {
                  name: 'DNA damage',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.DNADamage,
                  symbolSize: 5
                },
                {
                  name: 'DNA repair',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.DNARepair,
                  symbolSize: 5
                },
                {
                  name: 'EMT',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.EMT,
                  symbolSize: 5
                },
                {
                  name: 'Hypoxia',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Hypoxia,
                  symbolSize: 5
                },
                {
                  name: 'Inflammation',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Inflammation,
                  symbolSize: 5
                },
                {
                  name: 'Invasion',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Invasion,
                  symbolSize: 5
                },
                {
                  name: 'Metastasis',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Metastasis,
                  symbolSize: 5
                },
                {
                  name: 'Proliferation',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Proliferation,
                  symbolSize: 5
                },
                {
                  name: 'Quiescence',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Quiescence,
                  symbolSize: 5
                },
                {
                  name: 'Stemness',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: _this.state_data.Stemness,
                  symbolSize: 5
                },
              ]
            })
            // chartDom.setAttribute('_echarts_instance_', '')
            option && myChart.setOption(option,true);
          })
    },
    errorFunction(e) {
      console.log(e+"no img")
      document.getElementById('img_left').style.display = "none";
      document.getElementById('img_right').className = "right2";
      // document.getElementById('main').style.height = "800px";
      // document.getElementById('main').style.width = "800px";
    },
    sucessFunction(e){
      console.log(e+"have img")
      document.getElementById('img_left').style.display = "block";
      document.getElementById('img_right').className = "right";
      // document.getElementById('main').style.height = "600px";
    },
    getImgPath(){
      let _this = this
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost + '/state/img/'+_this.formData.DatasetID+ '/'+_this.formData.Sample)
          .then(function (response){
            console.log('img_path:')
            console.log(response)
            _this.img_path = response.data.img_path
            // console.log(_this.img_path)
          })
    },
    initEcharts(){
      let _this = this
      const chartDom = document.getElementById('main');
      const myChart = echarts.init(chartDom);
      let option;

      // let Angiogenesis = this.state_data.Angiogenesis;
      // let Apoptosis = this.state_data.Apoptosis;
      // let CellCycle = this.state_data.CellCycle
      // let Differentiation = this.state_data.Differentiation
      // let DNADamage = this.state_data.DNADamage
      // let DNARepair = this.state_data.DNARepair
      // let EMT = this.state_data.EMT
      // let Hypoxia = this.state_data.Hypoxia
      // let Inflammation = this.state_data.Inflammation
      // let Invasion = this.state_data.Invasion
      // let Metastasis = this.state_data.Metastasis
      // let Proliferation = this.state_data.Proliferation
      // let Quiescence = this.state_data.Quiescence
      // let Stemness = this.state_data.Stemness
      const schema = [
        { name: 'no', index: 0, text: 'no' },
        { name: 'x', index: 1, text: 'x' },
        { name: 'y', index: 2, text: 'y' },
        { name: 'spot', index: 3, text: 'spot' },
        { name: 'expression', index: 4, text: 'expression' },
      ];
      const itemStyle = {
        // opacity: 0.8,
        // shadowBlur: 10,
        // shadowOffsetX: 0,
        // shadowOffsetY: 0,
        // shadowColor: 'rgba(0,0,0,0.3)',
        emphasis: {
          focus : 'self'
        }
      };
      option = {
        color: ['#FF0000', '#FF8000', '#FFFF00', '#80FF00', '#00FF00', '#00FF80', '#00FFFF',
          '#0080FF', '#0000FF', '#7F00FF', '#FF00FF', '#FF007F', '#808080', '#FF7F7F'],
        legend: {
          // orient: 'vertical',
          x: 'center',
          y: 'top',
          // top: 10,
          padding: [
            5,  // 上
            10, // 右
            5,  // 下
            10, // 左
          ],
          data:
              ["Angiogenesis","Apoptosis","Cell cycle","Differentiation","DNA damage","DNA repair",
                "EMT","Hypoxia","Inflammation","Invasion","Metastasis","Proliferation","Quiescence","Stemness"],
          selectedMode: "single", // 单选
          selected:{
            'Angiogenesis': true,
            'Apoptosis': false,
            'Cell cycle': false,
            'Differentiation': false,
            'DNA damage': false,
            'DNA repair': false,
            'EMT': false,
            'Hypoxia': false,
            'Inflammation': false,
            'Invasion': false,
            'Metastasis': false,
            'Proliferation': false,
            'Quiescence': false,
            'Stemness': false
          },
          textStyle: {
            fontSize: 10
          }
        },
        grid: {
          left: '5%',
          right: '15%',
          top: '20%',
          bottom: '5%'
        },
        tooltip: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          formatter: function (param) {
            // console.log(param)
            var value = param.value;
            // prettier-ignore
            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                + param.seriesName
                + '</div>'
                // + schema[0].text + '：' + value[2] + '<br>'
                + schema[1].text + '：' + value[0] + '<br>'
                + schema[2].text + '：' + value[1] + '<br>'
                + schema[3].text + '：' + value[3] + '<br>'
                + schema[4].text + '：' + value[4] + '<br>';
          }
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        visualMap: [
          // {
          //   left: 'right',
          //   top: '10%',
          //   dimension: 2,
          //   min: 0,
          //   max: 250,
          //   itemWidth: 30,
          //   itemHeight: 120,
          //   calculable: true,
          //   precision: 0.1,
          //   text: ['圆形大小：PM2.5'],
          //   textGap: 30,
          //   inRange: {
          //     symbolSize: [10, 70]
          //   },
          //   outOfRange: {
          //     symbolSize: [10, 70],
          //     color: ['rgba(255,255,255,0.4)']
          //   },
          //   controller: {
          //     inRange: {
          //       color: ['#c23531']
          //     },
          //     outOfRange: {
          //       color: ['#999']
          //     }
          //   }
          // },
          {
            left: 'right',
            bottom: '30%',
            dimension: 4,
            type: 'continuous',
            calculable:true,                        //是否显示拖拽用的手柄（手柄能拖拽调整选中范围）
            realtime:true,                          //拖拽时，是否实时更新
            precision:3,                            //数据展示的小数精度，默认为0，无小数点
            min: 0,
            max: 1,
            itemHeight: 120,
            align:"auto",
            text: ['expression'],
            textGap: 30,
            inRange: {
              // colorLightness: [1, 0.4],
              color: ['blue','yellow', 'red']
            },
            outOfRange: {
              color: ['rgba(255,255,255,0.4)']
            },
            controller: {
              inRange: {
                color: ['blue','yellow', 'red']
                // color: ['#c23531']
                // color: ['#FFFFFF']
              },
              outOfRange: {
                color: ['#999']
              }
            }
          }
        ],
        series: [
          {
            type: 'scatter',
            itemStyle: itemStyle,
            large: true,                //是否开启大规模散点图的优化，在数据图形特别多的时候（>=5k）可以开启。开启后配合 largeThreshold 在数据量大于指定阈值的时候对绘制进行优化。缺点：优化后不能自定义设置单个数据项的样式。
            largeThreshold:5000,        //开启绘制优化的阈值。
            data: this.state_data.Angiogenesis,
            symbolSize: 5,
            name: 'Angiogenesis',
          },
          {
            name: 'Apoptosis',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.state_data.Apoptosis,
            symbolSize: 5
          },
          {
            name: 'Cell cycle',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.state_data.CellCycle,
            symbolSize: 5
          },
          {
            name: 'Differentiation',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.state_data.Differentiation,
            symbolSize: 5
          },
          {
            name: 'DNA damage',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.state_data.DNADamage,
            symbolSize: 5
          },
          {
            name: 'DNA repair',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.state_data.DNARepair,
            symbolSize: 5
          },
          {
            name: 'EMT',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.state_data.EMT,
            symbolSize: 5
          },
          {
            name: 'Hypoxia',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.state_data.Hypoxia,
            symbolSize: 5
          },
          {
            name: 'Inflammation',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.state_data.Inflammation,
            symbolSize: 5
          },
          {
            name: 'Invasion',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.state_data.Invasion,
            symbolSize: 5
          },
          {
            name: 'Metastasis',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.state_data.Metastasis,
            symbolSize: 5
          },
          {
            name: 'Proliferation',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.state_data.Proliferation,
            symbolSize: 5
          },
          {
            name: 'Quiescence',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.state_data.Quiescence,
            symbolSize: 5
          },
          {
            name: 'Stemness',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.state_data.Stemness,
            symbolSize: 5
          },
        ]
      };

      myChart.off('legendselectchanged') //解决重复触发
      myChart.on('legendselectchanged', function (params) {
        console.log('点击了', params.name);
        _this.formData.State = params.name;
        // _this.getStateData();
        // myChart.setOption({
        //   legend:{selected:{[params.name]: true}}
        // })
        // do something
        _this.changeSelect()
      });
      option && myChart.setOption(option);

    },
    initPage(){
      let _this = this
      _this.formData.State = 'Angiogenesis'
      console.log(_this.formData.DatasetID+" "+_this.formData.Type)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/state/'+ _this.formData.DatasetID
          +'/'+ _this.formData.Sample +'/'+ _this.formData.State )
          .then(function (response){
            console.log('stateData:')
            console.log(response.data)
            // _this.state_data = response.data
            let name = Object.keys(response.data).pop()
            console.log(name)
            _this.state_data[name] = response.data[name]
            // _this.state_data[_this.formData.State] = response.data[_this.formData.State]
            console.log(_this.state_data)
            _this.initEcharts()
          })
    }
  },
  mounted() {
    // this.initEcharts()
    this.getDatasets()
    this.getSample()
    this.getImgPath()
    this.initPage()
  }
}
</script>

<style scoped>
.content{
  width: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #FFFFFF;
  margin: 0;
  padding: 0;
}
.left{
  width: 50%;
  float: right;
  /*display: flex;*/
  /*flex-direction: row;*/
  /*justify-content: flex-end;*/
  /*align-items: flex-end;*/
}
.right{
  width: 50%;
  float: left;
}
.right2{
  width: 50%;
  margin-left: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
